import axios from "axios";

export default {
    async getAssegnazioni(dipendente_id: string) {
        const data = new FormData();
        data.append("where[assegnazioni_materiale_dipendente]", `${dipendente_id}`);
        data.append("orderby", "assegnazioni_materiale_data_assegnazione");
        data.append("orderdir", "DESC");

        const response = await axios.post(`rest/v1/search/assegnazioni_materiale`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response;
    },

    async setAssegnazione(assegnazione_id: string, data_ricezione: string) {
        const data = new FormData();
        data.append("assegnazioni_materiale_ricevuto", "1");
        data.append("assegnazioni_materiale_data_ricezione", data_ricezione);

        const response = await axios.post(`rest/v1/edit/assegnazioni_materiale/${assegnazione_id}`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            }
        });
        return response;
    }
};
